/*
 * Nucery bundle cart — "remove whole bundle" for Palo Alto's cart.
 *
 * The bundle builder adds a priced anchor + several $0 pieces, all sharing a
 * `_bundle` line-item property. cart-line-items.liquid groups them into one block
 * (cart-bundle-item.liquid) with a single [data-remove-bundle] button carrying the
 * whole group's line-item keys in [data-bundle-lines]. Removing the bundle must
 * clear every one of those lines at once, otherwise the shopper could orphan the
 * free pieces or drop the anchor and keep the pieces.
 *
 * We POST all keys -> 0 in one /cart/update.js call, then ask Palo Alto to re-render
 * its cart via the global CartDrawer instance (window.cart.getCart()).
 */
(function () {
  'use strict';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function refreshCart() {
    try {
      if (window.cart && typeof window.cart.getCart === 'function') {
        window.cart.getCart();
        return;
      }
    } catch (e) {}
    // No reachable cart instance (unexpected) — reload so the removal is reflected.
    window.location.reload();
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-remove-bundle]') : null;
      if (!btn) return;
      e.preventDefault();
      if (btn.getAttribute('data-loading') === '1') return;

      var raw = btn.getAttribute('data-bundle-lines') || '';
      var keys = raw
        .split(',')
        .map(function (k) { return k.trim(); })
        .filter(Boolean);
      if (!keys.length) return;

      btn.setAttribute('data-loading', '1');
      var block = btn.closest('[data-bundle]') || btn.closest('[data-cart-item]');
      if (block) block.classList.add('nbc-removing');

      var updates = {};
      keys.forEach(function (k) { updates[k] = 0; });

      fetch(root() + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function () {
          try { document.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true })); } catch (e2) {}
          refreshCart();
        })
        .catch(function () {
          btn.removeAttribute('data-loading');
          if (block) block.classList.remove('nbc-removing');
        });
    },
    false
  );
})();
